import log from 'loglevel'
import { isNil } from 'lodash/fp'
import { fetchUtils } from 'react-admin'

const env = process.env['ENV'] as string
export const url = !isNil(process.env['API_LOCAL'])
  ? 'http://localhost:14001/v1'
  : {
      prd: 'https://response-form.ops.terashite.jp/v1',
      stg: 'https://response-form-stg.ops.terashite.jp/v1',
      int: 'https://response-form-int.ops.dev.terashite.jp/v1',
      dev: 'https://response-form-dev.ops.terashite.jp/v1',
      exp: 'https://response-form-exp.ops.dev.terashite.jp/v1'
    }[env]
const accessTokenKey = 'token'
log.setLevel(log.levels.DEBUG)

export const getCustomHeaders = (
  options: fetchUtils.Options = {}
): Headers | undefined => {
  const token = localStorage.getItem(accessTokenKey)
  const customHeaders = (
    !isNil(options.headers)
      ? options.headers
      : new Headers({
          Accept: 'application/json'
        })
  ) as Headers
  if (!isNil(token)) {
    customHeaders.set('Authorization', `Bearer ${token}`)
  }
  return customHeaders
}
export const fetchJson = (
  url: string,
  options: fetchUtils.Options = {}
): any => {
  const customHeaders = getCustomHeaders(options)
  if (isNil(customHeaders)) return undefined
  options.headers = customHeaders
  return fetchUtils.fetchJson(url, options)
}

export const getFileUploadUrl = async (
  issueKey: string,
  fileName: string
): Promise<{ url: string } | undefined> => {
  const { status, json } = await fetchJson(
    `${
      url as string
    }/url/file/upload?backlogIssueKey=${issueKey}&fileName=${fileName}`,
    {
      method: 'GET'
    }
  )
  return status !== 200 ? undefined : json
}
